import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Stack, TextField, Typography, Card, Grid } from '@mui/material';
import { openSnackbar } from '../../redux/slices/common';
import { addDeliveryFeeData, fetchDeliveryData } from '../../redux/slices/metrc';
// import { Grid } from 'react-virtualized';
import MDButton from 'components/MDButton';
import { isValidNumber } from 'utilities/common';

export default function DeliveryMetrc() {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        metrcDeliveryFee: ""
    })
    const { loading: isBtnLoading = false } = useSelector(state => state?.metrc)

    const [errors, setErrors] = useState({})

    useEffect(() => {
        dispatch(fetchDeliveryData())
            .unwrap()
            .then(res => {
                setFormData({ metrcDeliveryFee: res?.metrcDeliveryFee })
                // showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                // showResponseMessage(err?.message, 'error');
            });
    }, [])

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    const validateReasons = () => {
        let isError = false
        let errors = {}
        if (!formData?.metrcDeliveryFee) {
            isError = true
            errors = { ...errors, metrcDeliveryFee: 'Delivery Fee is required' }
        }

        return { errors, isError }
    }
    const submitHandler = () => {
        const { isError, errors } = validateReasons()
        setErrors(errors)
        if (isError) return;
        setErrors({})
        const payload = {
            metrcDeliveryFee: Number(formData?.metrcDeliveryFee)
        }
        dispatch(addDeliveryFeeData({ data: payload }))
            .unwrap()
            .then(res => {
                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });
    }

    return (
        <>
            <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={3}>
                    <Typography variant='h5'>Delivery Fee</Typography>
                </Stack>

                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12} md={12}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mb={2}>
                            <TextField
                                InputProps={{
                                    startAdornment: formData?.metrcDeliveryFee ? '$' : "",
                                }}
                                className="form-input currency-field"
                                fullWidth
                                label={'Metrc Delivery Fee'}
                                name="metrcDeliveryFee"
                                value={formData?.metrcDeliveryFee || ''}
                                error={Boolean(errors?.metrcDeliveryFee)}
                                onChange={(e) => {
                                    if (e.target.value && !isValidNumber(e.target.value)) return;
                                    setFormData({ ...formData, metrcDeliveryFee: e.target.value });
                                }}
                                helperText={errors?.metrcDeliveryFee}
                            />
                            <MDButton
                                sx={{ minWidth: '160px' }}
                                type='button'
                                variant='contained'
                                color='primary'
                                onClick={() => submitHandler()} disabled={isBtnLoading} loading={isBtnLoading}
                            >
                                Update
                            </MDButton>                        
                        </Stack>
                    </Grid>
                </Grid>
            </Card>
        </>
    );
}